import { NoResizeScreenSizeCalculator, SceneManager } from "pixi-scenegraph";
import { ButtonOptions } from "../prefabs";
import { SocketClient } from "./SocketClient";
import { Application, ApplicationOptions } from "pixi.js";
import '@pixi/layout';
import '@pixi/layout/devtools';
import { Group, Tween } from "@tweenjs/tween.js";
import { LayoutSystemOptions } from "@pixi/layout";

export const SceneBackGroundColor = 0x206030;

export const builderColors = [0xfff000, 0x00fff0, 0xf000ff];
export const difficultyColors = [0x20ff20, 0xffff70, 0xffa511, 0xff4040, 0xd580ff];
export const difficultyNames = ["Easy", "Normal", "Hard", "Deadly", "Epic"];

export class FontName {
    /**
     * Default font.
     */
    public static Default = "BubblerOne";

    /**
     * Standard button font.
     */
    public static StandardButton = "BubblerOne";

    /**
     * Tooltip font.
     */
    public static Tooltip = "Saira";
}

export class BitmapTextStyles {
    /**
     * Standard button text style defining font, size and fill color.
     */
    public static ButtonTextStyle = {
        fontFamily: FontName.StandardButton,
        fontSize: 41,
        fill: 0xffff00,
    };

    /**
     * Standard button text style defining font, size and fill color.
     */
    public static SmallButtonTextStyle = {
        fontFamily: FontName.StandardButton,
        fontSize: 20,
        fill: 0xffff00,
    };

    /**
     * Standard label caption style defining font, size and fill color.
     */
    public static LabelCaptionStyle = {
        fontFamily: FontName.StandardButton,
        fontSize: 36,
        fill: 0xeeee99,
    };

    /**
     * Standard label text style defining font, size and fill color.
     */
    public static LabelTextStyle = {
        fontFamily: FontName.StandardButton,
        fontSize: 34,
        fill: 0xbbddbb,
    };

    public static BadgeEmptyStyle = {
        fontFamily: FontName.StandardButton,
        fontSize: 30,
        fill: 0x888833,
        wordWrap: true,
        wordWrapWidth: 310,
    };
    public static BadgeNotificationStyle = {
        fontFamily: FontName.StandardButton,
        fontSize: 30,
        fill: 0xeeee99,
        wordWrap: true,
        wordWrapWidth: 310,
    };
}

export const BTN_WIDTH = 200;
export const BTN_HEIGHT = 65;

export const SMALL_BTN_WIDTH = 40;
export const SMALL_BTN_HEIGHT = 40;

/**
 * Standard button options.
 */
export var standardButtonOptions: ButtonOptions = {
    style: BitmapTextStyles.ButtonTextStyle,
    caption: "button",
    textureName: "/assets/gui/btn.png",
    width: BTN_WIDTH,
    height: BTN_HEIGHT,
    ltrbSize: 9,
};

/**
 * Standard button options.
 */
export var smallButtonOptions: ButtonOptions = {
    style: BitmapTextStyles.SmallButtonTextStyle,
    caption: "button",
    textureName: "/assets/gui/btn-small.png",
    width: SMALL_BTN_WIDTH,
    height: SMALL_BTN_HEIGHT,
    ltrbSize: 6,
};

/**
 * Menu button options.
 */
export var menuButtonOptions: ButtonOptions = {
    style: { ...BitmapTextStyles.ButtonTextStyle, fill: 0xffff40, stroke: { color: 0x0, width: 1, join: 'round' }, fontSize: 40 },
    caption: "",
    textureName: "/assets/gui/btn-menu-atlas.png",
    width: 110,
    height: 110,
    ltrbSize: 0,
    highlightTint: 0x1fafff,
    isAtlas: false,
};

export const PRELOAD_SOUNDS = [
    "/assets/sounds/btn.ogg",
];

export const PRELOAD_IMAGES = [
    "/assets/forest-tile.png",
    "/assets/base-camp.png",

    "/assets/hud/wood.webp",
    "/assets/hud/stone.webp",
    "/assets/hud/copper.webp",
    "/assets/hud/food.webp",
    "/assets/hud/mana.webp",
    "/assets/hud/population.webp",

    "/assets/maps/map1-tile.webp",

    "/assets/buildings/building_01.png",
    "/assets/buildings/building_02.png",
    "/assets/buildings/building_03.png",
    "/assets/buildings/building_04.png",
    "/assets/buildings/building_05.png",
    "/assets/buildings/building_06.png",
    "/assets/buildings/building_07.png",
    "/assets/buildings/building_08.png",
    "/assets/buildings/building_09.png",
    "/assets/buildings/building_10.png",
    "/assets/buildings/building_11.png",
    "/assets/buildings/building_12.png",
    "/assets/buildings/building_13.png",
    "/assets/buildings/building_14.png",
    "/assets/buildings/building_15.png",
    "/assets/buildings/building_16.png",
    "/assets/buildings/building_17.png",
    "/assets/buildings/building_18.png",
    "/assets/buildings/building_19.png",
    "/assets/buildings/building_20.png",
    "/assets/buildings/building_21.png",
    "/assets/buildings/building_22.png",
    "/assets/buildings/building_23.png",

    "/assets/units/unit-001.png",
    "/assets/units/unit-002.png",
    "/assets/units/unit-003.png",
    "/assets/units/unit-004.png",
    "/assets/units/unit-005.png",
    "/assets/units/unit-006.png",
    "/assets/units/unit-007.png",

    "/assets/gui/hero-list.png",
    "/assets/gui/hero-slots-frame.png",
    "/assets/gui/panel-border.png",
    "/assets/gui/email-item-frame.png",
    "/assets/gui/panel-frame.png",
    "/assets/gui/hunting-groups-frame.png",
    "/assets/gui/btn-menu-atlas.png",
    "/assets/gui/btn-center.png",
    "/assets/gui/options/snd_music_on.png",
    "/assets/gui/options/snd_music_off.png",
    "/assets/gui/options/snd_fx_on.png",
    "/assets/gui/options/snd_fx_off.png",
    "/assets/gui/options/options.png",
    "/assets/gui/btn.png",
    "/assets/gui/btn-small.png",
    "/assets/gui/btn-close.png",
    "/assets/gui/btn-tab.png",
    "/assets/gui/btn-attack.png",
    "/assets/gui/btn-event-location.png",
    "/assets/gui/opt-unchecked.png",
    "/assets/gui/opt-checked.png",
    "/assets/gui/home-village.png",
    "/assets/gui/stone-wheel.png",
    "/assets/gui/disconnected.png",

    "/assets/gui/check-mark.png",
    "/assets/gui/x-mark.png",
    "/assets/gui/clover.png",
    "/assets/gui/builder-hammer.png"    
]

for (let i = 1; i <= 25; i++) {
    PRELOAD_IMAGES.push(`/assets/drops/resources/${i}.png`);
}
for (let i = 700; i <= 720; i++) {
    PRELOAD_IMAGES.push(`/assets/drops/equipment/${i}.png`);
}
for (let i = 400; i <= 449; i++) {
    PRELOAD_IMAGES.push(`/assets/drops/materials/${i}.png`);
}
for (let i = 100; i <= 124; i++) {
    PRELOAD_IMAGES.push(`/assets/drops/buffs/${i}.png`);
}

for (let i = 1; i <= 48; i++) {
    const nr = i.toString().padStart(2, '0');
    PRELOAD_IMAGES.push(`/assets/heroes/${nr}.webp`);
}

const tweenGroup = new Group();

/**
 * Creates a new tween added to the global tween group.
 * The global group is updated by the Pixi application ticker.
 * @param object
 * @returns
 */
export function tween(object: any): Tween {
    const tween = new Tween(object);
    tweenGroup.add(tween);
    return tween;
}

let pixiApp: Application;
let scm: SceneManager | undefined;
export async function initScm(): Promise<SceneManager> {
    if (pixiApp && pixiApp.renderer) {
        console.warn("Destroying existing Pixi application due to HMR.");
        pixiApp.destroy(true, { children: true }); // Destroy existing app if HMR occurs
    }
    pixiApp = new Application();
    const renderOptions: Partial<ApplicationOptions> = {
        backgroundColor: 0xff0055,
        antialias: true,
        backgroundAlpha: 1,
        resolution: window.devicePixelRatio,
        autoDensity: true,
        resizeTo: window,
        hello: true,
        preference: "webgpu",
        // renderableGCActive: false   //  try to disable auto GC probably causing TilledSprite 
        // //  'Uncaught TypeError: Cannot read properties of undefined (reading 'indices')'

        layout: {
            autoUpdate: true,
            //enableDebug: true,
            throttle: 100,
        } as any as LayoutSystemOptions,
    };
    await pixiApp.init(renderOptions);
    pixiApp.renderer.on('resize', syncRootSize); 
    console.log("PIXI is initialized!");

    if(scm){ 
        //scm.Destroy();
        scm = undefined;
    }       
    return getScm(); 
}
const syncRootSize = () => {
  const { width, height } = pixiApp.renderer.screen;
  if (pixiApp.stage.layout) {
    pixiApp.stage.layout.setStyle({ width, height });
  } else {
    pixiApp.stage.layout = { width, height, flexDirection: 'column' };
  }
};

export function getScm(): SceneManager {
    if (!scm) {
        scm = new SceneManager(
            pixiApp,
            undefined,
            undefined,
            new NoResizeScreenSizeCalculator(),
        );
        scm.Application.ticker.add(() => tweenGroup.update());
    }
    return scm;
}

let client: SocketClient | undefined;
export function getClient(): SocketClient {
    if (!client) {
        client = new SocketClient();
    }
    return client;
}